exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".body-table[data-v-f6d18cce]{height:calc(100% - 38px)}.body-table .cln-debut[data-v-f6d18cce],.body-table .cln-envoi[data-v-f6d18cce],.body-table .cln-etat[data-v-f6d18cce],.body-table .cln-fin[data-v-f6d18cce],.body-table .cln-nbr[data-v-f6d18cce],.body-table .cln-periode[data-v-f6d18cce]{width:13.5%}.body-table .cln-action[data-v-f6d18cce]{width:19%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-f6d18cce","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./src/components/Primobox/envoiBulletins/envoiBulletins.scss
// module id = v50D
// module chunks = 2